import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sf-modal-body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { clasS: "sf-modal-footer" }
const _hoisted_4 = {
  key: 0,
  class: "tw-text-xl tw-font-bold tw-mb-2"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Don't you have an account?  "),
  /*#__PURE__*/_createElementVNode("a", { href: "/register" }, " Register here ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, {
    show: _ctx.modalVisible,
    onClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('closed'))),
    "prevent-body-scroll": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Login to Mathsframe / Spellingframe ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_LoginForm, {
          screen: _ctx.screen,
          "login-mode": _ctx.loginMode,
          onSwitchscreen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.screen = $event)),
          onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalVisible = false)),
          onLoggedin: _ctx.onLoggedin
        }, null, 8, ["screen", "login-mode", "onLoggedin"]),
        (_ctx.screen == 'sent')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalVisible = false)),
                class: "sf-btn-primary"
              }, " Close ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.screen == 'login' && _ctx.mfLoginActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.loginMode == 'sf')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.loginMode = 'mf'), ["prevent"]))
                  }, " Log in with a Mathsframe username "))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.loginMode = 'sf'), ["prevent"]))
                  }, " Log in with a Spellingframe username "))
            ]))
          : _createCommentVNode("", true),
        (_ctx.screen != 'forgot' && _ctx.screen !== 'sent')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("a", {
                href: "",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.screen = 'forgot'), ["prevent"]))
              }, " Forgotten your login details? ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.screen != 'login' && _ctx.screen != 'loggedin')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", {
                href: "",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.screen = 'login'), ["prevent"]))
              }, " Back to login ")
            ]))
          : _createCommentVNode("", true),
        _hoisted_7
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}